import Vue from 'vue';
// eslint-disable-next-line goodt-rules/no-long-prop-chains
Vue.config.optionMergeStrategies.hooks = Vue.config.optionMergeStrategies.methods;
